module.exports = __webpack_public_path__ + "media/assets/signUpImg-85946e8ed5ba68823f3fa7ce8228b221.png";